import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['documentsContainer', 'documentTemplate'];

  addDocument(event) {
    event.preventDefault();
    
    const newDocument = this.createNewDocument();
    this.updateDocumentIndexes(newDocument);
    this.documentsContainerTarget.appendChild(newDocument);
  }

  removeDocument(event) {
    event.preventDefault();
    
    const documentField = event.target.closest('.document-field');
    if (documentField) {
      this.markDocumentForDeletion(documentField);
      this.hideDocumentField(documentField);
    }
  }

  createNewDocument() {
    const template = this.documentTemplateTarget;
    return template.content.cloneNode(true);
  }

  updateDocumentIndexes(newDocument) {
    const nextIndex = this.getNextDocumentIndex();
    
    this.updateInputNamesAndIds(newDocument, nextIndex);
    this.updateLabelAttributes(newDocument, nextIndex);
  }

  getNextDocumentIndex() {
    const existingDocuments = this.documentsContainerTarget.querySelectorAll('.document-field');
    return existingDocuments.length;
  }

  updateInputNamesAndIds(newDocument, index) {
    const inputs = newDocument.querySelectorAll('input, select');
    
    inputs.forEach((input) => {
      if (input.name) {
        input.name = input.name.replace('[new_document]', `[${index}]`);
      }
      if (input.id) {
        input.id = input.id.replace('new_document', index);
      }
    });
  }

  updateLabelAttributes(newDocument, index) {
    const labels = newDocument.querySelectorAll('label');
    
    labels.forEach((label) => {
      const forAttribute = label.getAttribute('for');
      if (forAttribute) {
        label.setAttribute('for', forAttribute.replace('new_document', index));
      }
    });
  }

  markDocumentForDeletion(documentField) {
    const destroyField = documentField.querySelector('input[name*="[_destroy]"]');
    if (destroyField) {
      destroyField.value = '1';
    }
  }

  hideDocumentField(documentField) {
    documentField.style.display = 'none';
  }
}
